// Sticky Nav

class StickyBar extends HTMLElement {
  static get observedAttributes() {
  }

  constructor() {
    super();
    this.stickHeader = "";
    const resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        if(document.querySelector(".sticky-header")){
            this.stickHeader  = document.querySelector(".sticky-header")
           this.parentNode.style.setProperty("--header-height",this.stickHeader.clientHeight+"px");
        }
      }
    });
    resizeObserver.observe(document.body);
    
    this.sticky_bar_height = 0;
    this.offset = 300;
    this.linkClicked = false;

    this.nav = this.querySelector('.cust-sticky-bar-items');
    const links = this.querySelectorAll('.cust-sticky-bar-item');
    const stickyBarBtn = this.querySelector('.cust-sticky-bar-button__btn');
    
    this.updateOnClickStickyNavState(links);
    this.trackBtnClick(stickyBarBtn); // Black friday promotion tracking

    window.onscroll =  () => {
      if(document.querySelector(".sticky-header") && this.stickHeader != document.querySelector(".sticky-header")){
        this.stickHeader  = document.querySelector(".sticky-header")
        this.parentNode.style.setProperty("--header-height",this.stickHeader.clientHeight+"px");
      }
      const scrollPos_start = window.scrollY + this.sticky_bar_height + this.offset;
      const scrollPos_end = window.scrollY + this.sticky_bar_height;

      if (!this.linkClicked) {
        this.updateStickyNavState(links, scrollPos_start);
      }
    };
  }
  
  attributeChangedCallback(name, oldValue, newValue){
  }

  connectedCallback() {
  }

  disconnectedCallback() {
  }

  adoptedCallback() {
  }


  updateOnClickStickyNavState(links) {
      links.forEach((e) => {
        var section_id = e.getAttribute('href') == '#' ? '#no-valid-selector' : e.getAttribute('href')
        var section_id_trans = section_id.toLowerCase().replace(/\s+/g, '-').replace(/[^-a-zA-Z0-9]/g, '')

        var refElement
        try {
          refElement = document.querySelector(section_id)
        } catch {
          refElement = document.querySelector(`[id="${section_id.replace('#', '')}"]`) || document.querySelector(section_id_trans)
        }

        if (refElement) {
          e.onclick =  (evt) => {
            // Prevent default anchor click behavior
            evt.preventDefault();
            window.dataLayer.push({
              event: "24_bflive_sticky_bar_clicks",
              tab_name: e.innerText
            });
            this.linkClicked = true;
            let scrollOffset = 100;
            if(window.outerWidth > 767){  
              scrollOffset = 50;
            }

            var section_top = refElement.getBoundingClientRect().top + window.scrollY - this.sticky_bar_height - scrollOffset;
            // Added a delay to fix scroll bug on first reload page
            setTimeout(function () {
              window.scroll({
                top: section_top,
                behavior: 'smooth',
              });
            }, 100);

            // Reset linkClicked flag after a delay (e.g., 1000ms)
            setTimeout( () => {
              this.linkClicked = false;
              const scrollPos_start = window.scrollY + this.sticky_bar_height + this.offset;
              const scrollPos_end = window.scrollY + this.sticky_bar_height;
              this.updateStickyNavState(links, scrollPos_start);
            }, 1000);
          };
        }
      });
    }

    updateStickyNavState(links, scrollPos_start) {
      links.forEach( (e) => {
        var section_id = e.getAttribute('href') == '#' ? '#no-valid-selector' : e.getAttribute('href')
        var section_id_trans = section_id.toLowerCase().replace(/\s+/g, '-').replace(/[^-a-zA-Z0-9]/g, '')

        var refElement
        try {
          refElement = document.querySelector(section_id)
        } catch {
          refElement = document.querySelector(`[id="${section_id.replace('#', '')}"]`) || document.querySelector(section_id_trans)
        }
        if (refElement) {
          const section_top = refElement.getBoundingClientRect().top + window.scrollY;
          if (scrollPos_start >= section_top) {
            links.forEach(function (link) {
              if (link !== e) {
                link.classList.remove('active');
              }
            });

            e.classList.add('active');

             this.nav.scrollTo(
               {
                 left: e.offsetLeft - 20,
                 behavior: "smooth"
               }
             )
          }
        }
      });
    }
  
  // Black friday promotion tracking
  trackBtnClick(element) {
    element.addEventListener('click', () => {
      window.dataLayer.push({
        event: "24_bflive_sticky_bar_clicks",
        subscribe_button_text: element.innerText
      });
    });
  }

}

customElements.define('sticky-bar', StickyBar);